/**
 * Carga
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Sistema} from '@/model/resource/Sistema'
import {Responsavel} from '@/model/resource/Responsavel'
import {Auditoria} from '@/model/resource/Auditoria'
import {Endereco} from '@/model/resource/Endereco'
import {Motorista} from '@/model/resource/Motorista'
import {TipoOcorrencia} from '@/model/resource/TipoOcorrencia'
import {PosicaoMotorista} from '@/model/resource/PosicaoMotorista'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'
import {StatusCarga} from '@/model/resource/StatusCarga'
import {TipoPessoaRecebedor} from '@/model/resource/TipoPessoaRecebedor'
import {CentroDeCusto} from '@/model/resource/CentroDeCusto'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {BatchRemoveCargaResponse} from '@/model/response/BatchRemoveCargaResponse'
import {WebhookReprocessarResponse} from '@/model/response/WebhhokReprocessarResponse'

/* TODO: review generated class */
export class Carga extends Resource {
  idCargaPk: number = 0

  @ResponseSerialize(Sistema)
  sistema1: Sistema | null = null

  @ResponseSerialize(Sistema)
  sistema2: Sistema | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(Auditoria)
  auditoria: Auditoria | null = null

  @ResponseSerialize(Endereco)
  endereco: Endereco | null = null

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  @ResponseSerialize(TipoOcorrencia)
  tipoOcorrencia: TipoOcorrencia | null = null

  @ResponseSerialize(PosicaoMotorista)
  posicaoMotorista: PosicaoMotorista | null = null

  @ResponseSerialize(ResponsavelFilial)
  responsavelFilial1: ResponsavelFilial | null = null

  @ResponseSerialize(ResponsavelFilial)
  responsavelFilial2: ResponsavelFilial | null = null

  @ResponseSerialize(Sistema)
  sistema3: Sistema | null = null

  @ResponseSerialize(Sistema)
  sistema4: Sistema | null = null

  @ResponseSerialize(StatusCarga)
  statusCarga: StatusCarga | null = null

  @ResponseSerialize(TipoPessoaRecebedor)
  tipoPessoaRecebedor: TipoPessoaRecebedor | null = null

  @ResponseSerialize(CentroDeCusto)
  cargaCentroDeCusto: CentroDeCusto[] | null = null

  danfe: string | null = null
  nroNotaFiscal: string | null = null
  dataCriacao: string | null = null
  ativo: boolean | null = null
  finalizadoViaWeb: boolean | null = null
  reprocessarRedesul: boolean | null = null
  processouEasyDoc: boolean | null = null
  idStatusFk: number | null = null

  qtdPaleteEntregue: number | null = null
  qtdPaleteRetirado: number | null = null
  nomeRecebedor: string | null = null
  documentoRecebedor: string | null = null
  rgRecebedor: string | null = null
  idCargaApp: string | null = null
  codigoBarra: string | null = null
  placaVeiculo: string | null = null
  tipoVeiculo: string | null = null
  nomeMotorista: string | null = null
  idResponsavelCriadorFk: number | null = null
  idMotoristaCriadorFk: number | null = null
  serialNumber: string | null = null
  cte: string | null = null
  protocolSsw: string | null = null
  idEmbarcadorCacheFk: number | null = null
  idTransportadorCacheFk: number | null = null
  sigla: string | null = null
  cpfMotorista: string | null = null
  cdCorreio: string | null = null
  xpedido: string | null = null
  distanciaParaDestinoEmMetros: number | null = null
  duracaoParaDestinoEmSegundos: number | null = null
  pontoReferenciaEntrega: string | null = null
  dataEmissaoDanfe: string | null = null
  dataInicioEntrega: string | null = null
  dataFinalizacao: string | null = null
  observacao: string | null = null
  latitudeEntrega: number | null = null
  longitudeEntrega: number | null = null
  devolvida: boolean | null = null
  latitudeCheckIn: number | null = null
  longitudeCheckIn: number | null = null
  dataCheckIn: string | null = null
  dataPrevisao: string | null = null
  possuiDanfe: boolean | null = null
  criadoViaPainel: boolean | null = null
  dataBaixaSistema: string | null = null
  dataRemocao: string | null = null
  distanciaCheckInEmMetros: number | null = null
  distanciaEntregaEmMetros: number | null = null
  idOcorrenciaFk: number | null = null
  idUltimaPosicaoMotoristaFk: number | null = null
  idSistemaCriadorFk: number | null = null
  idSistemaFinalizadorFk: number | null = null
  idSistemaRemovedorFk: number | null = null
  idRemovedorFk: number | null = null
  idUltimaAuditoriaFk: number | null = null
  idFilialEmbarcadorFk: number | null = null
  idFilialTransportadorFk: number | null = null
  idPessoaRecebedorFk: number | null = null

  get $id() {
    return this.idCargaPk
  }
  set $id(val) {
    this.idCargaPk = val
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  /**
   * Este endereço só será preenchido caso quem cadastrou a carga disse que não quer usar
   * o mesmo endereço do destinatário
   */
  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }
  set idEnderecoFk(val) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = val
  }

  /**
   * Gets a instance of a given ID of Carga
   */
  async getCarga(id: number) {
    return await Request.get(`/admin/carga/${id}`)
      .name('getCarga')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of Carga
   */
  async removeCarga() {
    return await Request.delete(`/admin/carga/${this.$id}`)
      .name('removeCarga')
      .asNumber()
      .getData()
  }

  /**
   * Deletes multiple instances of the given IDs of Carga
   */
  static async batchRemoveCarga(ids: number[]) {
    return await Request.post(`/admin/carga/delete`, {ids})
      .name('batchRemoveCarga')
      .as(BatchRemoveCargaResponse)
      .getData()
  }

  /**
   * Lists the instances of Carga
   */
  static async listCarga(params: any) {
    return await Request.get(`/admin/carga`, {params})
      .name('listCarga')
      .as(CargaCollection)
      .getData()
  }

  /**
   * Persists a new instance of Carga. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCarga() {
    return await Request.post(`/admin/carga`, this)
      .name('persistCarga')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Carga to use it in a CSV file
   */
  static async listCsvCarga(params: any) {
    return await Request.get(`/admin/carga/csv`, {params})
      .name('listCsvCarga')
      .as(CargaCollection)
      .getData()
  }

  /**
   * Reprocess multiple instances of the given IDs of Carga
   */
  static async batchReprocessarWebhook(cargas: number[]) {
    return await Request.post(`/admin/webhook/reprocessar`, {cargas})
      .name('batchRemoveCarga')
      .as(WebhookReprocessarResponse)
      .getData()
  }
}
